import Picture from '@/components/picture'

interface Props {
  addressTitle: string
  address: string
  image: string
  icon: string
  iconAlt: string
  alt: string
  loading?: 'lazy' | 'eager'
  imagePosition: 'left' | 'right'
  iconHeight?: number
  iconWidth?: number
}

const AddressWithImage = ({
  addressTitle,
  address,
  image,
  icon,
  iconAlt,
  alt,
  loading = 'lazy',
  imagePosition,
  iconHeight,
  iconWidth,
}: Props) => {
  return (
    <section className="border border-[#ECECEC] rounded flex md:flex-row flex-col overflow-hidden mt-11 md:items-center">
      <aside
        className={`block ${
          imagePosition === 'right' ? 'md:order-2' : 'md:order-1'
        } md:w-1/2`}
      >
        <Picture image={image} imageAlt={alt} height="100%" width="100%" />
      </aside>
      <article
        className={`${
          imagePosition === 'right'
            ? 'md:order-1 md:pr-11'
            : 'md:order-2 md:pl-11'
        } p-[30px] pr-[30px] md:w-1/2`}
      >
        <Picture
          image={icon}
          imageAlt={iconAlt}
          aria-hidden="true"
          loading={loading}
          height={iconHeight}
          width={iconWidth}
        />
        <p className="text-xl font-natosans-medium mt-6 mb-2.5">
          {addressTitle}
        </p>
        <address className="text-[#646464] not-italic text-base">
          {address}
        </address>
      </article>
    </section>
  )
}

export default AddressWithImage
